import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastOneFieldRequiredValidator = (fieldNames: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasAtLeastOneValue = fieldNames.some((fieldName) => {
      const value = control.get(fieldName) && control.get(fieldName).value;

      if (typeof value === 'string') {
        return Boolean(value.trim());
      }

      return value !== null && value !== undefined && value !== '';
    });

    return hasAtLeastOneValue
      ? null
      : { atLeastOneFieldRequired: { fieldNames } };
  };
};
